<template>
  <v-menu open-on-click top offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="inactif"
        v-on="on"
        class="mx-2"
        color="primary"
        :title="title"
        :loading="loading"
      >
        <v-icon left>{{ icone }}</v-icon
        >{{ libelle }}
      </v-btn>
    </template>
    <v-list dense nav max-width="150">
      <v-subheader
        ><v-icon left>mdi-alert-outline</v-icon
        ><b>Êtes-vous sûr?</b></v-subheader
      >
      <v-divider></v-divider>
      <v-list-item
        @click="
          {
          }
        "
        ><v-list-item-icon>
          <v-icon medium left color="red">mdi-cancel</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Non</v-list-item-title>
      </v-list-item>
      <v-list-item @click="confirmer()"
        ><v-list-item-icon>
          <v-icon medium left color="green">mdi-checkbox-marked-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Oui</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: "ButtonConfirmation",
  props: ["icone", "libelle", "title", "inactif", "loading"],
  data() {
    return {};
  },
  methods: {
    confirmer() {
      this.$emit("ok");
    }
  }
};
</script>
